import { useEffect } from 'react'

import { EMPTY_LIST, ENTITY_KEY_ID } from '../../../../constants/common'
import { useMinimizedModalsContext } from '../../../../hooks'
import { isListViewTypeWithPreview } from '../../../../utils/listViewType'

export function useMultipleViewTypeListPreviewActions({
  activeItem,
  excludeIds,
  isPerformingMassAction,
  itemActionsClosingActivePreview = EMPTY_LIST,
  itemIdKey = ENTITY_KEY_ID,
  listViewType,
  massActionsClosingActivePreview = EMPTY_LIST,
  minimizedModalScope,
  profileLoadersRef,
  selectAllPages,
  selectedIds,
  setActiveItem,
  setItemAction,
  setMassAction,
  shouldCloseActivePreviewRef,
}) {
  const { confirmBeforeAction } = useMinimizedModalsContext()

  function guardCloseActivePreview(action) {
    if (confirmBeforeAction) {
      confirmBeforeAction(action, { scope: minimizedModalScope })

      return
    }

    action()
  }

  async function handleReloadActivePreview(mutatedItemId) {
    const shouldCloseActivePreview = shouldCloseActivePreviewRef.current

    shouldCloseActivePreviewRef.current = false

    if (shouldCloseActivePreview) {
      setActiveItem(null)

      return
    }

    if (
      isListViewTypeWithPreview(listViewType) &&
      activeItem &&
      (mutatedItemId == null || String(mutatedItemId) === String(activeItem))
    ) {
      return profileLoadersRef.current?.handleReloadProfile()
    }
  }

  function handleSetMassAction(action) {
    if (activeItem && massActionsClosingActivePreview.includes(action)) {
      const isActiveItemAffected = selectAllPages
        ? !excludeIds.includes(activeItem)
        : selectedIds.includes(activeItem)

      guardCloseActivePreview(() => {
        shouldCloseActivePreviewRef.current = isActiveItemAffected

        setMassAction(action)
      })

      return
    }

    shouldCloseActivePreviewRef.current = false

    setMassAction(action)
  }

  function handleSetItemAction(action, item) {
    if (
      activeItem &&
      activeItem === item[itemIdKey] &&
      itemActionsClosingActivePreview.includes(action)
    ) {
      guardCloseActivePreview(() => {
        shouldCloseActivePreviewRef.current = true

        setItemAction(action, item)
      })

      return
    }

    shouldCloseActivePreviewRef.current = false

    setItemAction(action, item)
  }

  useEffect(() => {
    if (!isPerformingMassAction) {
      shouldCloseActivePreviewRef.current = false
    }
  }, [isPerformingMassAction])

  return {
    handleReloadActivePreview,
    handleSetItemAction,
    handleSetMassAction,
  }
}
